<template>
    <div id="reserve-number">
      <div  class="social-nav filter-blur-50 border-bottom-white-1-50" >
        <div class="nameContainer" style="width: 50vw">
          <router-link to="/personal" class="d-flex">
            <div class="homeIcon">
              <a><img src="../../assets/icons/homeIcon.svg" height="20px" width="20px"></a>
            </div>
          </router-link>
          <!--        <div class="arrowIcon">-->
          <!--          <img src="../../assets/icons/rightArrow.svg" height="15px" width="15px">-->
          <!--        </div>-->
          <!--        <router-link to="/roaming" class="d-flex">-->
          <!--          <div class="bundleTitle">-->
          <!--            {{digiltaTitle}}-->
          <!--          </div>-->
          <!--        </router-link>-->
          <div class="arrowIcon">
            <img src="../../assets/icons/rightArrow.svg" height="15px" width="15px">
          </div>
          <div class="titleName">{{$t('reserveNumber.mainTitle')}}</div>
        </div>
              <div :class="[this.$lang === 'ar' ? 'flex-start-center' : '', 'checkContainer']" >
                <form :class="[this.$lang === 'ar' ? 'flex-row-reverse' : '', 'filterForm']">
                  <div class="checkName">{{$t('popularBundles.showResults')}}</div>
                  <div class="check">
                    <input type="radio" id="pre" name="filter" value="0" checked @change="filter(0)" >
                    <label for="pre" class="radioLabel pre">{{$t('popularBundles.PrePaid')}}</label>
                  </div>
                  <div class="check">
                    <input type="radio" id="post" name="filter" value="1" @change="filter(1)" >
                    <label for="post" class="radioLabel post">{{$t('popularBundles.PostPaid')}}</label>
                  </div>
                </form>
              </div>
      </div>
      <div class="mainContent">
        <div class="background">
        <div class="selectContainer">
          <div class="firstTitle">
            {{firstTitle}}
          </div>
          <div class="firstDescription">
            {{description}}
          </div>
          <div class="filterContainer">
            <div class="filter">
              <div class="selector">
                <Dropdown
                  v-model="selectedType"
                  :options="searchType"
                  optionLabel="name"
                  placeholder="select"
                  @change="changeType"
                />
              </div>
              <div class="searchField">
                <input type="text" :placeholder="searchPlaceholder" v-model="searchNumber" @keypress.enter="searchButton" @input="filterValidation">
              </div>
              <div class="searchButton">
                <div class="searchBtn" @click="searchButton"> <div><img src="../../assets/icons/searchIcon.svg" style="width: 25px; transform: rotate(-45deg); height: 35px;" class="searchIcon"></div>
                  <div style="padding: 0 0.7vw">{{search}}</div>
                </div>
              </div>
              <div class="searchValidation" v-if="valid"  :class="lang === 'ar' ? 'arValidation' : 'enValidation'">{{searchValidation}}</div>
            </div>
          </div>
          <div class="tableHeader">
            <div class="headerContent">
              <div class="tableTitle" v-if="this.$lang === 'en'">Showing Results For {{typeFilter}} Numbers {{typeSelect}} {{numberSearched}}</div>
              <div class="tableTitle" v-if="this.$lang === 'ar'">ظهور النتائج للأرقام {{typeFilter}} التي {{typeSelect}}  {{numberSearched}}</div> <div class="results"> {{total}}  {{$t('reserveNumber.results')}}</div>
            </div>
          </div>
        </div>
        </div>
        <table class="tableContainer" style="width:100%">
          <div v-if="show && !error" style="height: 100%; width: 100%; display: flex; justify-content: center; align-items: center; min-height: 400px">
            <Loader />
          </div>
          <Error v-if="error" style="height: 100%; width: 100%; display: flex; justify-content: center; align-items: center; min-height: calc(100vh - 780px);"/>
          <div v-if="!isUserAuthenticated()" style="height: 100%; width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center; min-height: 400px; padding: 20px;">
            <div style="font-size: 18px; font-family: Mtn-bold; color: #FFCB05; margin-bottom: 15px;">
              {{$t('reserveNumber.loginRequired') || 'Login Required'}}
            </div>
            <div style="font-size: 14px; font-family: Mtn-regular; color: #666; text-align: center; margin-bottom: 20px;">
              {{$t('reserveNumber.loginMessage') || 'Please log in to reserve a number'}}
            </div>
            <button @click="$store.state.loginDialog = true" class="login-btn" style="background: #FFCB05; color: #000; border: none; padding: 10px 20px; border-radius: 5px; font-family: Mtn-bold; cursor: pointer;">
              {{$t('welcomeMenu.login') || 'Login'}}
            </button>
          </div>
          <div v-if="!show && !error && isUserAuthenticated()">
          <tr class="tableRow" v-for="item in numbers" :key="item.id">
            <div class="rowContainer">
            <div class="number">
              {{item}}
            </div>
            <div class="reserveButtonContainer">
              <router-link to="/Reservation">
                <a>
              <div class="reserveButton" @click="reserve(item)" :class="lang === 'ar' ? 'arabicFont' : ''">
                {{btn}}
              </div>
                </a>
              </router-link>
            </div>
            </div>
          </tr>
          </div>
        </table>
        <div class="containerPag">
          <div class="pagination-container">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalElements"
              :per-page="size"
              aria-controls="my-table"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Dropdown from 'primevue/dropdown'
import $ from 'jquery'
import Loader from '../../components/LoaderBtn/Loader'
import Error from '../../components/errorHandle/Error'
// import ms from '../../utils/messeging'
import ReservationNumberRepositiory from '../../repositories/ReservationNumberRepositiory'
export default {
  name: 'index',
  components: { Dropdown, Loader, Error },
  data () {
    return {
      lang: this.$lang,
      reservationNumber: new ReservationNumberRepositiory(),
      firstTitle: this.$t('reserveNumber.title'),
      description: this.$t('reserveNumber.description'),
      btn: this.$t('reserveNumber.reserve'),
      search: this.$t('reserveNumber.search'),
      searchNumber: '',
      searchPlaceholder: this.$t('reserveNumber.searchPlaceholder'),
      selectedType: null,
      searchType: [
        { name: this.$t('reserveNumber.content'), code: '0' },
        { name: this.$t('reserveNumber.start'), code: '1' },
        { name: this.$t('reserveNumber.end'), code: '2' }
      ],
      searchCode: '1',
      numbers: [],
      filterType: 0,
      size: 5,
      currentPage: 1,
      totalElements: 0,
      typeFilter: this.$t('popularBundles.PrePaid'),
      typeSelect: this.$t('reserveNumber.start'),
      numberSearched: '5',
      showing: this.$t('popularBundles.showing'),
      total: 0,
      searchValidation: '',
      valid: false,
      show: true,
      error: false,
      submited: false
    }
  },
  computed: {
    rows () {
      return this.numbers.length
    }
  },
  mounted () {
    this.arabic()
    this.selectedType = this.searchType[1]
    localStorage.setItem('typeForReserve', 0)
    window.addEventListener('resize', () => {
      if (window.innerWidth < 700) {
        this.searchType[1].name = this.$t('reserveNumber.smallStart')
      } else {
        this.searchType[1].name = this.$t('reserveNumber.start')
      }
    })
    if (window.innerWidth < 700) {
      this.searchType[1].name = this.$t('reserveNumber.smallStart')
    }
  },
  created () {
    // Check if user is authenticated before proceeding
    if (!this.isUserAuthenticated()) {
      this.$store.state.loginDialog = true
      return
    }
    this.searchNumber = 5
    this.getSearch()
  },
  methods: {
    isUserAuthenticated () {
      return this.$store.state.user.gsm !== null && this.$store.state.user.token !== null
    },
    changeType () {
      this.searchCode = this.selectedType.code
      this.typeSelect = this.selectedType.name
      this.searchButton()
    },
    reserve (val) {
      // Check authentication before allowing reservation
      if (!this.isUserAuthenticated()) {
        this.$store.state.loginDialog = true
        return
      }
      localStorage.setItem('ReservedNumber', val)
    },
    arabic () {
      if (this.$lang === 'ar') {
        $('.social-nav, .mainContent').css('direction', 'rtl')
        $('.mainContainer').css('direction', 'rtl')
        $('.mtnRadioText, .headerContent').css('text-align', 'right')
        $('.checkName, .firstTitle, .reserveButton, .searchBtn, #reserve-number .titleName').css('font-family', 'Mtn-arabic-bold')
        $('.checkContainer, .buttons, .number').css('direction', 'ltr')
        $('.radioLabel').css('font-family', 'Mtn-regular')
        $('.firstDescription, .searchField,  .p-dropdown-items, .results, #reserve-number .p-dropdown-item').css('font-family', 'Mtn-arabic-regular')
        $('.headerContent, #reserve-number .p-inputtext').css('font-family', 'Mtn-arabic-medium')
        $('.arrowIcon').css('transform', 'rotateY(180deg)')
        $('.searchField').addClass('rightBorder')
        $('.searchField').removeClass('leftBorder')
        $('#reserve-number .checkName').css('direction', 'rtl')
        this.arabicRadio()
      } else if (this.$lang === 'en') {
        $('.searchField').removeClass('rightBorder')
        $('.searchField').addClass('leftBorder')
        $('#reserve-number .checkName').css('direction', 'ltr')
      }
    },
    filter (val) {
      // Check authentication before allowing filter changes
      if (!this.isUserAuthenticated()) {
        this.$store.state.loginDialog = true
        return
      }

      this.filterType = val
      if (val === 0) {
        this.typeFilter = this.$t('popularBundles.PrePaid')
      } else if (val === 1) {
        this.typeFilter = this.$t('popularBundles.PostPaid')
      }
      this.arabicRadio()
      localStorage.setItem('typeForReserve', val)
      this.currentPage = 1
      if (this.valid === false) {
        this.getSearch()
      }
    },
    arabicRadio () {
      if (this.$lang === 'ar') {
        $('.post').css('font-family', 'Mtn-arabic-regular')
        $('.pre').css('font-family', 'Mtn-arabic-regular')
        $('.post').css('font-size', '10px')
        $('.pre').css('font-size', '10px')
        if ($('#pre').is(':checked')) {
          $('.pre').css('font-family', 'Mtn-arabic-bold')
          $('.pre').css('font-size', '10px')
          // $('.post').css('font-family', 'Mtn-arabic-regular')
          // $('.post').css('font-size', '11px')
        } else if ($('#post').is(':checked')) {
          $('.post').css('font-family', 'Mtn-arabic-bold')
          $('.post').css('font-size', '10px')
          // $('.pre').css('font-family', 'Mtn-arabic-regular')
          // $('.pre').css('font-size', '11px')
        }
      }
    },
    filterValidation () {
      if (this.submited === true) {
        const startValidation = /^[4567][0-9]{0,7}$/
        const endValidation = /^[0-9]{1,8}$/
        if (this.searchNumber === '') {
          this.searchValidation = this.$t('reservationFilter.required')
        } else if (this.searchNumber !== '') {
          this.searchValidation = ''
        }
        if (this.searchCode === '1' && this.searchNumber !== '') {
          if (startValidation.test(this.searchNumber) === false) {
            this.searchValidation = this.$t('reservationFilter.valid')
            this.valid = true
            return false
          } else if (startValidation.test(this.searchNumber) === true) {
            this.searchValidation = ''
          }
        } else if (this.searchCode === '0' && this.searchNumber !== '') {
          if (endValidation.test(this.searchNumber) === false) {
            this.searchValidation = this.$t('reservationFilter.valid')
            this.valid = true
            return false
          } else if (this.searchCode === '2' && this.searchNumber !== '') {
            if (endValidation.test(this.searchNumber) === false) {
              this.searchValidation = this.$t('reservationFilter.valid')
              this.valid = true
              return false
            }
          } else if (endValidation.test(this.searchNumber) === true) {
            this.searchValidation = ''
          }
        }
      }
    },
    startWithValidation () {
      const startValidation = /^[4567][0-9]{0,7}$/
      if (startValidation.test(this.searchNumber) === false) {
        this.searchValidation = this.$t('reservationFilter.valid')
        this.valid = true
        return false
      } else {
        this.valid = false
        this.show = true
        return true
      }
    },
    endAndContentValidation () {
      const endValidation = /^[0-9]{1,8}$/
      if (endValidation.test(this.searchNumber) === false) {
        this.searchValidation = this.$t('reservationFilter.valid')
        this.show = false
        this.valid = true
        return false
      } else {
        this.valid = false
        this.show = true
        return true
      }
    },
    searchButton () {
      // Check authentication before allowing search
      if (!this.isUserAuthenticated()) {
        this.$store.state.loginDialog = true
        return
      }

      this.numberSearched = this.searchNumber
      this.currentPage = 1
      this.submited = true
      if (this.searchNumber === '') {
        this.searchValidation = this.$t('reservationFilter.required')
        this.show = false
        this.valid = true
      }
      if (this.searchNumber !== '') {
        if (this.searchCode === '1') {
          this.startWithValidation()
        } else if (this.searchCode === '0') {
          this.endAndContentValidation()
        } else if (this.searchCode === '2') {
          this.endAndContentValidation()
        }
      }
      if (this.valid === false) {
        this.getSearch()
      }
    },
    async getSearch () {
      // Check authentication before making API call
      if (!this.isUserAuthenticated()) {
        this.$store.state.loginDialog = true
        return
      }

      this.show = true
      try {
        const formData = new FormData()
        if (this.searchCode === '1') {
          formData.append('startWithFilter', this.searchNumber)
        }
        if (this.searchCode === '0' || this.searchCode === '2') {
          formData.append('endWithOrContainFilter', this.searchNumber)
        }
        formData.append('searchType', this.searchCode)
        formData.append('lineType', this.filterType)
        const page = this.currentPage
        const size = this.size
        const response = await this.reservationNumber.postReservation(formData, page, size)
        if (response.data.status === 200) {
          this.show = false
          this.numbers = response.data.data.data
          this.total = response.data.data.totalElements
          this.totalElements = response.data.data.totalElements
          if (this.total === 0) {
            $('.tableContainer').css('min-height', '73px')
          }
        } else {
          this.isLoading = false
          this.show = true
        }
      } catch (e) {
        this.error = true
        this.show = false
        console.log(e)
      }
    }
  },
  watch: {
    // Watch for authentication state changes
    '$store.state.user.gsm': {
      handler (newGsm) {
        if (newGsm && this.isUserAuthenticated()) {
          // User just logged in, refresh the data
          this.getSearch()
        }
      },
      immediate: false
    },
    async currentPage (val) {
      // Check authentication before pagination
      if (!this.isUserAuthenticated()) {
        this.$store.state.loginDialog = true
        return
      }

      this.show = true
      this.numbers = []
      const formData = new FormData()
      if (this.searchCode === '1') {
        formData.append('startWithFilter', this.searchNumber)
      }
      if (this.searchCode === '0' || this.searchCode === '2') {
        formData.append('endWithOrContainFilter', this.searchNumber)
      }
      formData.append('searchType', this.searchCode)
      formData.append('lineType', this.filterType)
      try {
        const page = val - 1
        const size = this.size
        const response = await this.reservationNumber.postReservation(formData, page, size)
        if (response.data.status === 200) {
          this.show = false
          this.numbers = []
          if (page === this.currentPage - 1) {
            this.numbers = response.data.data.data
            this.totalElements = response.data.data.totalElements
          } else {
            return
          }
        } else {
        }
      } catch (e) {
        console.log(e)
        this.show = false
        this.error = true
      }
      this.loader = false
    }
  }
}
</script>

<style scoped lang="scss">
  @import "src/assets/sass/main";
  @import "~primevue/resources/primevue.min.css";
  @import "~primeicons/primeicons.css";
  #reserve-number{
    padding-top: 160px;
  }
  #reserve-number .social-nav{
    //background: rgba(212, 212, 212, 0.45);
    //background-color: $--light-white;
    height: 50px;
    //box-shadow: 10px 10px 30px 0px rgba(0, 0, 0, 0.1) !important;
    background: rgba(242, 242, 242, 1);
    box-shadow: 0 15px 25px rgba(0, 0, 0, 0.1);
    //backdrop-filter: blur(40px);
    margin: 0px 0px;
    display: flex;
    position: fixed;
    z-index: 10;
    z-index: 210;
    top: 110px;
  }
  .arabicBack{
    right: 4vw;
    left: unset !important;
    transform: rotateY(180deg);
  }
  .arabicSearch{
    right: 0 !important;
    left: unset !important;
  }
  #reserve-number .nameContainer{
    display: flex;
    padding: 0 4vw 0 3.2vw;
  }
  #reserve-number .homeIcon {
    cursor: pointer;
  }
  .homeIcon,
  .arrowIcon,
  .titleName{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 1vw;
  }
  #reserve-number .titleName{
    width: max-content;
    color: $--yellow;
    font-family: Mtn-bold;
    text-decoration: underline;
  }
  #reserve-number .bundleTitle{
    width: max-content;
    font-family: Mtn-regular;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 1vw;
  }
  .backArrow{
    width: 35px;
    height: 35px;
    margin-bottom: 50px;
  }
  .filterForm{
    display: flex;
  }
  .checkContainer{
    display: flex;
    justify-content: flex-end;
    width: 50vw;
    padding: 0 3vw;
    font-family: Mtn-regular;
  }
  .check{
    padding: 0 2vw;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .checkName{
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Mtn-bold;
    font-style: italic;
  }
  [type="radio"]:checked,
  [type="radio"]:not(:checked) {
    position: absolute;
    left: -9999px;
  }
  [type="radio"]:checked + label,
  [type="radio"]:not(:checked) + label
  {
    position: relative;
    padding-left: 28px;
    cursor: pointer;
    line-height: 20px;
    display: inline-block;
    color: #1D1D1D;
  }
  [type="radio"]:checked + label:before,
  [type="radio"]:not(:checked) + label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 18px;
    height: 18px;
    border: 2.5px solid $--yellow;
    border-radius: 100%;
    background: transparent;
  }
  [type="radio"]:checked + label:after,
  [type="radio"]:not(:checked) + label:after {
    content: '';
    width: 8px;
    height: 8px;
    background: $--yellow;
    position: absolute;
    top: 5px;
    left: 5px;
    border-radius: 100%;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }
  [type="radio"]:not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  [type="radio"]:checked + label:after {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
    font-weight: bold;
  }
  input[type="radio"]:checked+label {
    font-family: Mtn-bold;
    /*font-family: Mtn-arabic-bold;*/
  }
  @media screen and (max-width: 650px) {
    .checkName {
      display: none;
    }
  }
  @media screen and (max-width: 950px) {
    .homeIcon,
    .arrowIcon,
    #Digital-services .bundleTitle,
    .checkName{
      display: none;
    }
    .nameContainer{
      width: 50vw !important;
    }
  }
  .background{
    background-image: url("../../assets/icons/reserveNumberLeft.svg"), url("../../assets/icons/reserveNumberRight.svg");
    background-position-x: left, right;
    background-size: contain;
  }
  .selectContainer{
    min-height: 350px;
    background: rgb(255 255 255 / 50%);
    backdrop-filter: blur(7px);
    position: relative;
  }
  .tableContainer{
    min-height: 400px;
    background-image: linear-gradient(to right, #F2F2F2, #efefef);
    /*position: relative;*/
  }
  .tableHeader{
    background-image: linear-gradient(to right, #F2F2F2, #efefef);
    min-height: 70px;
    position: absolute;
    width: 100%;
    bottom: 0;
    border-radius: 15px 15px 0 0;
    border-top: 1px white solid;
    display: flex;
    justify-content: center;
  }
  .headerContent{
    min-height: 50px;
    border-bottom: 1.5px solid #FFCB05;
    width: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .containerPag{
    width: 100%;
    display: flex;
    justify-content: center;
    background-image: linear-gradient(to right, #F2F2F2, #efefef);
    padding: 30px 20px;
  }
  .tableRow{
    display: flex;
    justify-content: center;
  }
  .rowContainer{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 75px;
    border-bottom: 1px rgb(0 0 0 / 30%) solid;
    width: 85%;
  }
  .number,
  .reserveButtonContainer {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .reserveButtonContainer{
    padding-left: 5vw;
  }
  .number{
    color: #FFCB05;
    font-family: Mtn-medium;
    font-style: italic;
    font-size: 20px;
  }
  .reserveButton{
    width: 160px;
    height: 50px;
    border: 2px #FFCB05 solid;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-family: Mtn-bold;
    font-size: 13px;
  }
  .firstTitle{
    padding: 36px 2vw 5px;
    font-size: 25px;
    color: #FFCB05;
    font-family: Mtn-bold;
    font-style: italic;
  }
  .firstDescription{
    padding: 0 5vw
  }
  .headerContent{
    color: #FFCB05;
    font-family: Mtn-medium;
  }
  .filterContainer{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 50px 5vw;
  }
  .filter {
    width: 100%;
    background: rgb(255 255 255 / 25%);
    height: 70px;
    border: 2px #FFCB05 solid;
    border-radius: 20px;
    max-width: 800px;
    display: flex;
    position: relative;
  }
  .selector,
  .searchButton,
  .searchField {
    height: 100%;
  }
  .selector {
    width: 20%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .searchButton {
    width: 30%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 7px;
  }
  .searchField {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 50%;
    padding: 0 1.5vw
  }
  .leftBorder {
    border-left: 2px #FFCB05 solid;
  }
  .rightBorder {
    border-right: 2px #FFCB05 solid;
  }
  .searchField input {
    width: 100%;
  }
  .searchBtn{
    max-width: 160px;
    width: 100%;
    height: 50px;
    /*border: 2px #FFCB05 solid;*/
    background-color: #FFCB05;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-family: Mtn-bold;
    font-style: italic;
    font-size: 13px;
    box-shadow: 10px 13px 16px -6px rgba(0, 0, 0, 0.1);
  }
  .tableTitle{
    padding: 0 5vw;
  }
  .results {
    color: black;
    font-family: 'Mtn-regular';
    font-style: italic;
  }
  @media screen and (max-width: 600px) {
  .searchIcon{
    display: none;
  }
  .searchBtn{
    justify-content: center;
  }
  }
  @media screen and (max-width: 500px) {
    .nameContainer{
      width: 40vw !important;
    }
    .checkContainer{
      width: 60vw !important;
    }
    .selector{
      width: 30%;
    }
  }
  @media screen and (max-width: 1080px) {
    .background{
      background-image: url("../../assets/icons/reserveNumberLeft.svg");
      background-position-x: right;
      background-size: contain;
    }
  }
  #reserve-number table tr:last-child .rowContainer {
    border-bottom: none !important;
  }
  #reserve-number table tr:first-child .rowContainer {
    margin-top: 25px;
  }
  .searchValidation{
    position: absolute;
    /*left: 22%;*/
    top: 70px;
    font-size: 11px;
    color: red;
  }
</style>
<style lang="scss">
  #reserve-number{
    /*--------------- pagination -----------------------*/
    span.page-link {
      background: transparent !important;
      padding: 0;
      border: none;
    }
    .pagination-container{
      background: #FFFFFF;
      height: 70px;
      width: 99%;
      /*margin-top: 40px;*/
      /*position: absolute;*/
      /*bottom: 35px;*/
      border-radius: 25px;
    }
    ul.pagination.b-pagination{
      width: 50%;
      padding: 0;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-around;
      height: 100%;
    }
   .containerPag li:first-child,
   .containerPag li:last-child{
      display: none;
    }
    li:nth-child(2),
    li:nth-last-child(2) {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      span.page-link,
      button.page-link{
        padding: 0 0 2px 0 !important;
        display: block;
        background: transparent;
        color: black;
        border: 3px solid #FFCB05;
        border-radius: 50%;
        width: 45px;
        height: 45px;
        font-size: 16px;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    button.page-link:focus,
    span.page-link{
      outline: none !important;
      box-shadow: none;
    }
    li.page-item.active:focus{
      outline: none !important;
      border:none !important;
    }
    button.page-link,
    .page-link.active, .active > .page-link{
      background: transparent;
      border: none;
      color: #d3d3d3;
      font-size: 14px;
    }
    .page-link.active, .active > .page-link{
      color: #FFCB05;
    }
    .p-dropdown-items{
      padding-left: 0 !important;
      font-family: Mtn-arabic-regular !important;
    }
    .p-inputtext {
      padding: 5px 1vw;
      color: #FFCB05;
      text-decoration: underline;
      font-family: 'Mtn-medium';
      min-width: 100px;
    }
    .pi {
      color: #FFCB05;
    }
    .p-dropdown-items{
      font-family: Mtn-regular;
    }
    .p-dropdown-item{
      padding: 10px 0;
    }
    .p-dropdown-panel{
      background: white;
      border-radius: 15px;
      top: 30px !important
    }
    @media screen and (max-width: 730px) {
      /*.p-dropdown{*/
      /* display: block;*/
      /*}*/
      .p-inputtext {
        min-width: unset !important;
      }
      .p-dropdown-panel {
        min-width: 120px;
        top: 40px !important;
        left: -25px !important;
      }
    }
    @media screen and (max-width: 470px) {
      .selector {
        font-size: 12px;
      }
    }
  }
  @media screen and (max-width: 900px) {
    ul.pagination.b-pagination{
      width: 70% !important;
    }
  }
  .arabicFont{
    font-family: Mtn-arabic-bold !important;
  }
  .arValidation {
   right: 22%;
  }
  .enValidation {
    left: 22%;
  }
</style>
